import { render, staticRenderFns } from "./FeedbackButtonComponent.vue?vue&type=template&id=5b0067ed&scoped=true"
import script from "./FeedbackButtonComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0067ed",
  null
  
)

export default component.exports